__webpack_require__.p = "/wp-content/plugins/Kalkulator-roi/app/build/";